import { ThemeInterface } from "injectors/theme";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: ThemeInterface) => ({
  screenWrapper: { position: "relative", overflowY: "auto", height: "100%" },
}));

export { useStyles };
